import $ from 'jquery';
import 'jquery.easing';
import debounce from 'lodash/debounce';

window.jQuery = $;
window.debounce = debounce;

$('document').ready(function () {
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/lib/lib.js